<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container fluid>
    <v-layout align-center justify-center row>
      <v-flex xs10>
        <v-container fluid grid-list-md>
          <v-layout row justify-center align-center>
            <pricing-card v-for="(item, i) in data.filter(it => it.ilk_satis === 1)" :key="`${item.id}-${i}`"
              :item="item">
              <template v-slot:pricing-btn>
                <div v-if="item.paketsms < 50000 && item.id !== 44">
                  <button class="main-btn eft-btn mb-3" @click="goToBankAccounts">
                    Havale/EFT ile Satın Al<br />({{ item.fiyat }} TL)
                  </button>
                  <!-- <button class="main-btn credit-btn" @click="buyPack(item)">
                    Kredi Kartı ile Satın Al<br />({{ item.kredi_karti_tutar }} TL)
                  </button> -->
                </div>
                <div v-else>
                  <button class="main-btn eft-btn" @click="getOffer(item)">
                    Teklif Alınız
                  </button>
                </div>
              </template>
            </pricing-card>
            <pricing-card v-for="(item, i) in data.filter(it => it.ilk_satis === 0 && it.kampanya_ozel === 1)" :key="i"
              :item="item">
              <template v-slot:pricing-btn>
                <div v-if="item.paketsms < 50000 && item.id !== 44">

                  <button class="main-btn eft-btn mb-3" style="background: #FC0;" @click="goToBankAccounts">
                    Havale/EFT ile Satın Al<br />({{ item.fiyat }} TL)
                  </button>
                  <!-- <button v-if="data.kredi_karti_alim === 0" class="main-btn credit-btn" @click="buyPack(item)">
                    Kredi Kartı ile Satın Al<br />({{ item.kredi_karti_tutar }} TL)
                  </button> -->
                </div>
                <div v-else>
                  <button class="main-btn eft-btn" @click="getOffer(item)">
                    Teklif Alınız
                  </button>
                </div>
              </template>
            </pricing-card>
          </v-layout>
          <v-layout row>
            <pricing-card v-for="(item, i) in data.filter(
              it => it.ilk_satis === 0 && it.paketsms > 0 && it.kampanya_ozel === 0)" :key="i" :item="item">
              <template v-slot:pricing-btn>
                <div v-if="item.paketsms < 50000 && item.id !== 44">

                  <button class="main-btn eft-btn mb-3" @click="goToBankAccounts">
                    Havale/EFT ile Satın Al<br />({{ item.fiyat }} TL)
                  </button>
                  <!-- <button class="main-btn credit-btn" @click="buyPack(item)">
                    Kredi Kartı ile Satın Al<br />({{ item.kredi_karti_tutar }} TL)
                  </button> -->
                </div>
                <div v-else>
                  <button class="main-btn eft-btn" @click="getOffer(item)">
                    Teklif Alınız
                  </button>
                </div>
              </template>
            </pricing-card>
          </v-layout>
          <div class="mt-8">
            <v-divider></v-divider>
            <v-card-subtitle class="text-sm-center text-h4">SMS İptal Çözümleri</v-card-subtitle>
          </div>
          <v-layout row justify-center align-center>
            <pricing-card v-for="(item, i) in data.filter(it => it.tip == 121 || it.tip == 122)" :key="i" :item="item"
              :conditional-class="'sms-iptal'">
              <template v-slot:pricing-btn>
                <button class="main-btn eft-btn mt-3" @click="getOffer(item)">
                  TEKLİF ALINIZ
                </button>
              </template>
            </pricing-card>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>

    <!-- Modal for collecting user info -->
    <v-dialog v-model="offerDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">Teklif Alınız</v-card-title>
        <v-card-text>
          <v-form ref="offerForm">
            <v-text-field v-model="offerFormData.fullname" label="Ad Soyad" required></v-text-field>
            <v-text-field v-model="offerFormData.phone" label="Telefon" required></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="offerDialog = false">İptal</v-btn>
          <v-btn color="blue darken-1" text @click="submitOffer">Gönder</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- FAQ Section -->
    <v-container class="mt-10">
        <v-card-text>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
              <strong>  Sms Paket Fiyatları, Kullanım ve Ücretlendirme Detayları</strong>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <p>Fiyatlarımıza KDV ve ÖİV dahildir. Ekstra ücret talep edilmez.</p>
                <p>Toplu sms Tarifeleri Başlıklı veya Abone numaralı (0850'li numaralı) sms paketleri için de aynıdır.
                </p>
                <p>Belirtilen sms paketi fiyatları dışında herhangi (sistem kurulumu teknik destek vb.. için) bir ücret
                  talep edilmez.</p>
                <p>BTK'nın yeni fiyat tarifesi ile mevcut paketleriniz 31.12.2024 tarihine kadar geçerlidir. SMS
                  Kredileriniz 01.01.2024 tarihinden itibaren yeni fiyatlara göre revize edilecektir.</p>
                <p>Yukarıdaki ücretler peşin ödenir ödenen tutara istinaden hesabınıza kontör yüklenir.</p>
                <p>Faturalar e-fatura olarak kesilir ve mail adresinize gönderilmektedir. Mail adresinizin doğruluğundan
                  ve
                  geçerliliğinden emin olunuz.</p>
                <p>Toplu Mesaj paketlerimizin son kullanım tarihi bulunmamaktadır. Mevcut kontörleriniz hiçbir zaman
                  silinmez istediğiniz süre içerisinde kullanabilirsiniz.</p>
                <p>BAŞLI Toplu mesaj gönderdiğinizde kullanacağınız gönderici adınızdır Orjinatör diye de bilinir.
                  Başlıklar
                  en az 3 en fazla 11 karakter olmalıdır. Başlık tanımlaması için gerekli evraklar tarafımıza ulaştıktan
                  sonra BTK tarafından belirtilen yasal çerçevede oluşturulur. Birden fazla gönderici adınız olabilir ve
                  gönderimlerde istediğinizi seçerek mesaj yollayabilirsiniz.</p>
                <p>İçeriği 160 karaktere kadar her bir Standart mesaj 1 kontörle ücretlendirilir. Göndereceğiniz mesajın
                  boyutunun 160 karakterden daha uzun olması halinde her 152 karakter için 1 kontör ücret yansıtılır.
                  Örneğin 612 karakterlik bir mesaj 4 katı daha büyük olduğundan 4 kontör ücreti kredinizden düşer.</p>
                <p>Detaylı raporlama ile gönderilen mesajların yerine ulaşıp ulaşmadığını anında kontrol edebilirsiniz.
                  Siz
                  sadece yerine ulaşan (Alıcı telefona başarıyla teslim edilen) gönderimleriniz için
                  ücretlendirilirsiniz.
                  Ulaşmayan mesajlarınız için hesabınızdan düşürülen kontör en geç 24 saat içinde iade edilir.</p>
                <p>Dilerseniz kredi iadelerinizi kendiniz de o anda sistemden yükleyebilirsiniz. Ayrıca geriye dönük tüm
                  iade işlemlerinizi de panel üzerinden görebilirsiniz.</p>
                <p>Mesaj Sistemi kullanımı rehber kaydı grup oluşturulması üyelerinizin sisteme kaydı konularında
                  ücretsiz
                  teknik destek hizmeti verilmektedir.</p>
                <p>Yazılım firmaları ya da programcılar için sağladığımız ücretsiz API bağlantı hizmetini kullanarak
                  mevcut
                  yazılımlarınıza gerekli entegrasyonları sağlayabilirsiniz. Api entegrasyonunda ücretsiz yazılım
                  desteği
                  sağlamaktayız.</p>
                <p>Kişisel veya Kurumunuza (şirket dernek okul hastane sendika site yönetimi v.b..) özel fiyat teklifi
                  için
                  destek@vatansms.com email adresimizden bizimle iletişime geçebilir ya da iletişim sayfamızdan bize
                  mesaj
                  yazabilirsiniz.</p>
                <p>VATAN SMS Toplu sms paketlerinde: tarife indirim oranı tarih hediye ve kullanım koşullarında
                  degişiklik
                  yapma hakkını saklı tutar.</p>
                <p>VatanSMS operatörler arası ara bağlantı ücretlendirmelerinde değişiklik olması halinde; yürürlükte
                  bulunan mevzuata uygun şekilde; tarifelerinde paketten kullanım-düşüm ve ücretlendirme şartlarında
                  değişiklik yapabilir.</p>
              </v-expansion-panel-content>
            </v-expansion-panel>

          </v-expansion-panels>
        </v-card-text>
    </v-container>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import PricingCard from '../../Components/PricingCard.vue';
import PluggableAsDialog from '../../Components/Pluggable/PluggableAsDialog.vue';

export default {
  name: 'Prices',
  components: {
    PluggableAsDialog,
    PricingCard
  },
  data: () => ({
    data: [],
    offerDialog: false,
    offerFormData: {
      fullname: '',
      phone: '',
    },
    selectedPack: null,
    headers: [
      {
        text: 'Başlık',
        value: 'paketadi',
        align: 'left'
      },
      {
        text: 'Havale/Eft',
        value: 'buy'
      },
      {
        text: 'Kredi Kartı',
        value: 'buy_credit_card'
      },
    ],
  }),
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    loadData() {
      this.send({ route: 'show/prices' })
        .then((res) => {
          this.data = res.data.data;
        });
    },
    buyPack(pack) {
      if (this.$store.state.user.confirmation === '4') {
        this.$trigger('setPluginDialog');
        return;
      }
      this.send({
        route: 'buy',
        data: { id: pack.id }
      })
        .then((res) => {
          this.$router.push({ name: 'payments.card', params: { payCredit: res.data.data } });
        });
    },
    getOffer(pack) {
      if (this.$store.state.user.confirmation === '4') {
        this.$trigger('setPluginDialog');
        return;
      }
      this.selectedPack = pack;
      this.offerDialog = true;
    },
    submitOffer() {
      if (this.$refs.offerForm.validate()) {
        this.send({
          route: 'get-offer',
          data: {
            id: this.selectedPack.id,
            name: this.offerFormData.fullname,
            phone: this.offerFormData.phone
          }
        })
          .then((res) => {
            this.offerDialog = false;
            // Additional logic can be added here to handle response if needed
          });
      }
    },
    goToBankAccounts() {
      if (this.$store.state.user.confirmation === '4') {
        this.$trigger('setPluginDialog');
        return;
      }
      this.$router.push('/bank/accounts');
    },
  },
  created() {
    this.loadData();
  },
};
</script>
